import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink } from "lucide-react";

const Sostenibilita = () => {
  return (
    <main data-testid="sostenibilita-page" className="bg-ivory text-navy min-h-screen pt-24">
      <div className="container-editorial py-20 md:py-28 max-w-3xl">
        <Link
          to="/"
          data-testid="back-home"
          className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-muteText hover:text-navy mb-12"
        >
          <ArrowLeft size={14} /> Torna alla home
        </Link>

        <p className="overline mb-6">Documento informativo</p>
        <h1 className="display-2 mb-10">Informativa sui rischi di sostenibilità</h1>

        <div className="space-y-6 text-muteText leading-relaxed text-base md:text-lg">
          <p>
            Ai sensi dell'Art. 165 comma 1 lett. h-bis del Regolamento
            Intermediari, nel processo di selezione degli strumenti
            finanziari oggetto del servizio di consulenza in materia di
            investimenti, il consulente Manuel Faustini integra una
            valutazione in merito ai fattori di sostenibilità ambientale,
            sociale e di governance, al fine di garantire che i vari
            prodotti e strumenti possano essere raccomandati solamente a
            clienti che esprimono preferenze in tema di sostenibilità
            compatibili con le caratteristiche degli stessi strumenti.
          </p>
          <p>
            Dato che la consulenza svolta dal consulente Manuel Faustini
            riguarda il portafoglio finanziario nel suo complesso, la
            valutazione dei fattori di sostenibilità viene svolta a livello
            di portafoglio. Ciò significa che, nel suo complesso, il
            portafoglio dovrà essere allineato alle preferenze di
            sostenibilità del cliente, anche se è possibile che, per ragioni
            di gestione del rischio o di raggiungimento degli obiettivi del
            cliente, alcuni singoli strumenti utilizzati non siano
            singolarmente allineati alle preferenze del cliente.
          </p>
          <p>
            La valutazione delle caratteristiche di sostenibilità
            ambientale, sociale e di governance viene svolta, a seconda
            della tipologia di strumento/prodotto, secondo le informazioni
            dichiarate dall'emittente ai sensi delle regolamentazioni
            vigenti oppure utilizzando modelli di valutazione esterni
            (rating) e/o analisi svolte internamente.
          </p>
        </div>

        <div className="mt-12 border-t border-line pt-10">
          <p className="text-sm text-muteText mb-4">
            Per maggiori informazioni fare riferimento al sito ufficiale ACF
            — CONSOB:
          </p>
          <a
            data-testid="acf-link"
            href="https://www.acf.consob.it/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Visita acf.consob.it <ExternalLink size={16} />
          </a>
        </div>

        <p className="text-xs tracking-[0.22em] uppercase text-muteText mt-16">
          Ultimo aggiornamento: dicembre 2025
        </p>
      </div>
    </main>
  );
};

export default Sostenibilita;
